import Link from "next/link";
import Color from "../../../../assets/colors";
import { getLastActiveAtTime } from "../../../../helpers/conditional_rendering";
import { currencies } from "../../../../helpers/constant";
import {
  BoxStyled,
  CardStyled,
  CurrencyIconStyled,
  DivStyled,
  IconTextContainer,
  LabelStyled,
  MapPinStyled,
} from "./styles";

function SingleJobHighlight(props) {
  const { job, locationFilter, handleHref } = props;

  const getTime = (job) => {
    let createdAtDate = job.createdAt || job.created_at;
    let jobCreatedAt = getLastActiveAtTime(createdAtDate);

    return jobCreatedAt;
  };

  function formatSalary(input, crossBorderData) {
    const geoEnv = process.env.NEXT_PUBLIC_JSW_GEOLOCATION;
    let currency;

    // prioritise source_country as it may be jobs utilising "cross border token"
    // if no source_country, it means the job is from the target geolocation of ur api (e.g. my-api OR sg-api)
    // therefore, fallback is to just use geolocation ENV
    if (crossBorderData?.source_country) {
      currency = currencies[crossBorderData?.source_country];
    } else if (geoEnv === "sg") {
      currency = "SGD";
    } else {
      currency = "RM";
    }

    if (!input?.includes(" - ")) {
      const salaryNumber = Number(input?.replace(currency, ""));
      if (salaryNumber < 10000) {
        return `${currency} ${salaryNumber}`;
      }
      const salaryInK = salaryNumber / 1000;
      const startDecimals = salaryInK?.toFixed(1) % 1 === 0 ? 0 : 1;
      return `${currency} ${salaryInK?.toFixed(startDecimals)}K`;
    }
    const [startSalary, endSalary] = input?.split(" - ");

    const startNumber = Number(startSalary?.replace("RM", ""));

    if (startNumber === 0) {
      return `${endSalary}`;
    }

    const endNumber = Number(endSalary?.replace(currency, ""));

    if (startNumber < 10000 && endNumber < 10000) {
      return `${currency} ${startNumber} - ${currency} ${endNumber}`;
    }

    const startSalaryInK = startNumber / 1000;
    const endSalaryInK = endNumber / 1000;

    const startDecimals = startSalaryInK?.toFixed(1) % 1 === 0 ? 0 : 1;
    const endDecimals = endSalaryInK?.toFixed(1) % 1 === 0 ? 0 : 1;

    return `${currency} ${startSalaryInK?.toFixed(
      startDecimals
    )}K - ${currency} ${endSalaryInK?.toFixed(endDecimals)}K`;
  }

  return (
    <CardStyled>
      <BoxStyled flexDirection={"column"} gap={"0.5rem"}>
        <IconTextContainer aria-label="job-salary">
          <CurrencyIconStyled />
          <LabelStyled aria-label="job-salary-value" variant="body1">
            {job?.salary === "Undisclosed" || job?.salary === "Undefined"
              ? "Undisclosed"
              : formatSalary(job?.salary, job?.crossBorderData)}
          </LabelStyled>
        </IconTextContainer>

        <IconTextContainer aria-label="job-location">
          <MapPinStyled />
          <LabelStyled
            aria-label="job-location-value"
            variant="body1"
            flexWrap={"wrap"}
            textOverflow={"ellipsis"}
            overflow={"hidden"}
            whiteSpace={"nowrap"}
          >
            {locationFilter(job)}
          </LabelStyled>
        </IconTextContainer>
      </BoxStyled>

      <IconTextContainer>
        <DivStyled
          container
          justifyContent={
            job.jobType || job.job_type ? "space-between" : "flex-start"
          }
          alignItems={"center"}
        >
          {job.jobType || job.job_type ? (
            <Link
              href={handleHref("jobType", job)}
              style={{ textDecoration: "none" }}
            >
              <DivStyled
                style={{
                  background: Color.lightBlue,
                  padding: "0 0.5rem",
                  borderRadius: "0.25rem",
                  color: Color.blue,
                  cursor: "pointer",
                }}
              >
                <LabelStyled
                  variant="body1"
                  fontWeight={"bold"}
                  fontSize={"14px"}
                  aria-label="job-type"
                  sx={{
                    color: Color.blue,
                  }}
                >
                  {job?.jobType
                    ? job?.jobType
                    : job?.job_type
                    ? job?.job_type
                    : null}
                </LabelStyled>
              </DivStyled>
            </Link>
          ) : null}
          <LabelStyled
            aria-label="employer-estimate-last-active"
            variant="body1"
            fontSize={"14px"}
          >
            {getTime(job)}
          </LabelStyled>
        </DivStyled>
      </IconTextContainer>
    </CardStyled>
  );
}

export default SingleJobHighlight;
